// src/utils/debugExperiments/experiments.ts

/**
 * Catalog of debug experiments.
 *
 * Each experiment has:
 * - `label`: human-readable text shown in DevToolsButton.
 * - `dataAttr`: kebab-case suffix appended to `data-exp-` on <html>.
 * - `default`: initial value if nothing is in localStorage.
 *
 * To add an experiment:
 * 1. Append an entry here.
 * 2. Add the matching CSS override in `src/styles/_debug-experiments.scss`
 *    (selector: `html[data-exp-<dataAttr>="1"]`) and/or wire the value
 *    via `useExperiment(...)` in the relevant component.
 */
export const EXPERIMENTS = {
  noBlurHalo: {
    label: "No blur halo (::before)",
    dataAttr: "no-blur-halo",
    default: false
  },
  noAnimGlow: {
    label: "No animation: missionGlow",
    dataAttr: "no-anim-glow",
    default: false
  },
  noDropShadow: {
    label: "No filter: drop-shadow",
    dataAttr: "no-drop-shadow",
    default: false
  },
  noBoxShadowGlow: {
    label: "No large box-shadow (Store/Preform)",
    dataAttr: "no-box-shadow-glow",
    default: false
  },
  solidSideMenu: {
    label: "Solid sideMenu (no decor)",
    dataAttr: "solid-side-menu",
    default: false
  },
  noChestFeedFilters: {
    label: "No filters in chestDropsFeed",
    dataAttr: "no-chest-feed-filters",
    default: false
  },
  noLottie: {
    label: "No Lottie animations",
    dataAttr: "no-lottie",
    default: false
  }
} as const

export type ExperimentKey = keyof typeof EXPERIMENTS
